import React from "react"
import { Formik } from "formik"

import { useSignupSubmission } from "../../hooks/useSignupSubmission"
import { SIGNUP_STATES, validateSignupValues } from "../../utils/signup"
import Success from "../../images/success-tick.png"
import { ReactComponent as ErrorIcon } from "../../images/invalid-email.svg"
import {
  SignUpContainer,
  SupportiveText,
  Form,
  SubmitButton,
  Sent,
  ErrorMessage,
} from "./style"

const SignUp = ({ white, article }) => {
  const {
    submissionState,
    submitError,
    submitSignup,
    resetFeedback,
  } = useSignupSubmission("community_signup")

  const isSubmitting = submissionState === SIGNUP_STATES.submitting
  const isSuccess = submissionState === SIGNUP_STATES.success
  const fieldMessage = submitError

  return (
    <SignUpContainer article={article} white={white}>
      {white ? null : (
        <SupportiveText>Want to see your work here?</SupportiveText>
      )}

      <Formik
        initialValues={{ email: "", website: "" }}
        validateOnChange={false}
        validate={validateSignupValues}
        onSubmit={async (values, { resetForm, setSubmitting }) => {
          const didSucceed = await submitSignup(values)

          setSubmitting(false)

          if (didSucceed) {
            resetForm()
          }
        }}
      >
        {({ values, errors, handleChange, handleSubmit }) => {
          const errorMessage = errors.email || fieldMessage

          return (
            <Form
              showError={errorMessage}
              onSubmit={handleSubmit}
              disabled={isSubmitting || isSuccess}
              white={white}
            >
              <Sent disabled={isSuccess} white={white}>
                <img src={Success} alt="" />
                <p>
                  {white ? "Thanks" : "Thank you"} for subscribing!
                  <br /> We'll be in touch soon.
                </p>
              </Sent>

              <input
                type="text"
                name="email"
                id="email"
                disabled={isSubmitting || isSuccess}
                value={isSuccess ? "" : values.email}
                onChange={event => {
                  resetFeedback()
                  handleChange(event)
                }}
                spellCheck={false}
                placeholder={
                  isSuccess
                    ? ""
                    : white
                    ? "Your email address..."
                    : "Enter your email address..."
                }
              />

              <div className="signup-honeypot" aria-hidden="true">
                <label htmlFor="community-signup-website">Website</label>
                <input
                  type="text"
                  name="website"
                  id="community-signup-website"
                  tabIndex="-1"
                  autoComplete="off"
                  value={values.website}
                  onChange={event => {
                    resetFeedback()
                    handleChange(event)
                  }}
                />
              </div>

              <SubmitButton type="submit" disabled={isSubmitting || isSuccess}>
                {white ? "Hook me up" : "Join our community"}
              </SubmitButton>

              <ErrorMessage
                showError={errorMessage}
                name="email"
                disabled={isSubmitting || isSuccess}
                white={white}
              >
                <ErrorIcon />
                <p>{errorMessage}</p>
              </ErrorMessage>
            </Form>
          )
        }}
      </Formik>
    </SignUpContainer>
  )
}

export default SignUp
